<template>
    <div class="partner">
        <p class="partner__title">Powered by the following partners:</p>
        <PartnerImg divclass="partner__img"></PartnerImg>
        <!-- <div class="partner__img">
            <img src="/img/partner/konsulta.png" alt="Konsulta" class="konsulta">
            <img src="/img/partner/FamilyDOC.png" alt="FamilyDOC" class="family">
            <img src="/img/partner/healthway.png" alt="Healthway" class="healthway">
            <img src="/img/partner/generika.png" alt="Generika" class="generika">
        </div> -->
    </div>
</template>
<script>
import PartnerImg from './PartnerImg.vue';

export default {
  name: 'Partner',
  components: {
    PartnerImg,
  },
};
</script>
